import React, { useRef, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import rutaTematicaApi from '../api/ruta-tematica';
import { select_lang } from './Location';
const parse = require('url-parse');

const useRutaTematicaData = () => {
    let opclang = select_lang();
    const [data, setData] = useState([]);
    const [isValid, setIsValid] = useState(false);
    let { idrt = null, opc = null, idt = null } = parse(location.href, true).query;
    if (idt != null) {
        idrt = idt.replace(/[a-zA-Z]+$/, "");
        opc = idt.replace(/^[0-9]+/, "");
    }

    useEffect(() => {
        if (idrt && opc) {
            rutaTematicaApi.get(`/rutatematica/${idrt}/${opc}`).then(res => {
                setData(res.data.data);
                setIsValid(true);
            }).catch(err => {
                setData(null);
            })
        }
    }, [idrt, opc]);


    return [{ data, params: [idrt, opc] }, isValid];
}

const renderLink = (text, url, withSlash = true) => {
    return (
        <React.Fragment key={text}>
            <li key={text}>
                {url === "" ? text : <a href={url}>{text}</a>}
            </li>
            {withSlash ? <li>/</li> : null}
        </React.Fragment>
    )
}

const renderUrl = (navigation) => {
    let opclang = select_lang();
    let newUrl = [renderLink(opclang['home'], "/default.html")]
    if (navigation.params[1] === "p")
        newUrl.push(renderLink(opclang['programs'], "/programas"))
    else
        newUrl.push(renderLink(opclang['themes'], "/datos"))

    navigation.data.forEach((t, index, arr) => {
        if (index === arr.length - 1)
            newUrl.push(renderLink(t.texto, t.enlace, false))
        else
            newUrl.push(renderLink(t.texto, t.enlace))
    });
    return newUrl;
}

const RutaTematica = () => {
    const [{ data, params }, isValid] = useRutaTematicaData();
    const opclang = select_lang();

    if (!isValid){
        return (
        <bnavegacion-inegi titulo="" seccion="temas">
            <nav className="pt-2" aria-labelledby="mn_titulo">
                <h2 id="mn_titulo" className="d-none">Menú de navegación</h2>

                <ol className="breadcrumb">
                    <li className="breadcrumb-item d-none d-lg-block">
                        <a href="/default.html">{opclang['home']}</a>
                    </li>

                    <li className="breadcrumb-item active" aria-current="page">
                        {opclang['themes']}
                    </li>
                </ol>
            </nav>
        </bnavegacion-inegi>
    );
    }
    else{
    return (
        <bnavegacion-inegi titulo="" seccion="temas">
            <nav className="pt-2" aria-labelledby="mn_titulo">
                <h2 id="mn_titulo" className="d-none">Menú de navegación</h2>

                <ol className="breadcrumb">
                    {/* Inicio */}
                    <li className="breadcrumb-item d-none d-lg-block">
                        <a href="/default.html">{opclang['home']}</a>
                    </li>

                    {/* Temas o Programas */}
                    <li className="breadcrumb-item">
                        <a href={params[1] === "p" ? "/programas" : "/temas"}>
                            {params[1] === "p" ? opclang['programs'] : opclang['themes']}
                        </a>
                    </li>

                    {/* Dinámico desde API */}
                    {data.map((t, index) => {
                        const isLast = index === data.length - 1;

                        return (
                            <li
                                key={index}
                                className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                                {...(isLast ? { "aria-current": "page" } : {})}
                            >
                                {isLast ? (
                                    t.texto
                                ) : (
                                    <a href={t.enlace}>{t.texto}</a>
                                )}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </bnavegacion-inegi>
    );
}
};

export default RutaTematica;
